import cntl from "cntl";
import React, { useRef } from "react";
import { eventColor } from "../../../helpers/Calendar";
import getDateTimeInTimezone from "../../../helpers/Calendar/getDateTimeInTimezone";
import useEventInfoButtonData from "./useEventInfoButtonData";

const buttonCntl = (selectedEvent, eventId) => cntl`
  hover:bg-lightgreen
  cursor-pointer
  p-2
  mt-2
  ${
    selectedEvent === eventId &&
    cntl`
    bg-lightgreen
    rounded
    border
    border-t
    border-green
    shadow-medium-lift
  `
  }
`;

const EventInfoButton = ({
  event,
  key,
  selectedEvent,
  setSelectedEvent,
  calendarTimezone,
  closePopup,
}) => {
  const {
    toggleInfoModal,
    eventButtonStyles,
    indicatorStyles,
    eventButtonTextStyles,
  } = useEventInfoButtonData(
    setSelectedEvent,
    event?.daySpan,
    eventColor(event)
  );

  // ref for the button to get the position
  const buttonRef = useRef(null);

  const handleInfoModal = () => {
    // get the position of the button via buttonRef
    const { width, height, left, top } =
      buttonRef.current.getBoundingClientRect();

    // set the selected event and open the modal
    setSelectedEvent(event.id);
    toggleInfoModal(event, {
      x: left,
      y: top - 150,
      width,
      height,
    });

    closePopup();
  };

  return (
    <button
      ref={buttonRef}
      type="button"
      key={key}
      style={eventButtonStyles}
      className={buttonCntl(selectedEvent, event.id)}
      onClick={() => handleInfoModal()}
    >
      {/* This circle is colored based on the event type. 
          Green: task, Purple: event, Pink: Maintenance
          Do not show circle if allDay Event/Task
      */}
      {!event?.daySpan && (
        <svg width="10" height="10" viewBox="0 0 20 20" style={indicatorStyles}>
          <circle cx="10" cy="10" r="10" fill={eventColor(event)} />
        </svg>
      )}
      <p
        className={`text-es-xs font-es-normal ${
          event?.daySpan && "p-2 rounded-md"
        }`}
        style={eventButtonTextStyles}
      >
        {/* Time in format h:mm A */}
        <span>
          {getDateTimeInTimezone({
            date: event.startDate,
            timezone: calendarTimezone,
            format: "h:mm A",
          })}
        </span>{" "}
        {event.name}
      </p>
    </button>
  );
};

export default EventInfoButton;
